import MfButton from './MfButton.vue';
/**
 * Diálogo de confirmação da biblioteca
 * @component
 */
export default {
  name: 'MfConfirmDialog',
  components: {
    MfButton
  },
  props: {
    /**
     * @model
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * Indica se o botão de confirmação terá a cor branca na fonte (não se aplica a outlined e text)
     */
    dark: {
      type: Boolean,
      default: false
    },
    /**
     * Título do diálogo
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Label do botão de Confirmar
     */
    confirmText: {
      type: String,
      default: 'Sim'
    },
    /**
     * Label do botão de Cancelar
     */
    cancelText: {
      type: String,
      default: 'Não'
    },
    /**
     * Indica se o botão de Confirmar está em estado de loading
     */
    confirmLoading: {
      type: Boolean,
      default: false
    },
    /**
     * Indica se o botão de Cancelar está em estado de loading
     */
    cancelLoading: {
      type: Boolean,
      default: false
    },
    /**
     * Indica se o botão de Confirmar está desabilitado
     */
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Indica se o botão de Cancelar está desabilitado
     */
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Cor do botão de Confirmar
     */
    confirmColor: {
      type: String,
      default: 'marca-0-l10'
    },
    /**
     * Cor do botão de Cancelar
     */
    cancelColor: {
      type: String,
      default: 'marca-0-l10'
    },
    /**
     * Mensagem do diálogo
     */
    message: {
      type: String,
      default: ''
    },
    /**
     * Indica que botão de Cancelar não será renderizado
     */
    hideCancel: {
      type: Boolean,
      default: false
    },
    /**
     * Indica que botão de Confirmar não será renderizado
     */
    hideConfirm: {
      type: Boolean,
      default: false
    },
    /**
     * Indica que nenhum botão de ação será renderizado
     */
    hideActionButtons: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  computed: {
    openModal: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    },
    formattedMessage() {
      return this.message.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    }
  }
};